import {
  Box,
  Button,
  Dialog,
  HStack,
  IconButton,
  Link,
  Portal
} from "@chakra-ui/react"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import { getPreviewUrl } from "@pathwright/ux/src/components/filestack/api"
import { useSize } from "@pathwright/ux/src/utils/size"
import PropTypes from "prop-types"
import { useEffect, useState } from "react"

const PREVIEW_ID = "filestack-preview"

const FilestackPreviewModal = ({
  previewHandle,
  previewURL: propsPreviewURL,
  downloadURL,
  children
}) => {
  const [previewURL, setPreviewURL] = useState(null)
  const [headerRef, headerHeight] = useSize("height")

  useEffect(() => {
    if (propsPreviewURL) {
      return
    }

    getPreviewUrl(previewHandle).then(setPreviewURL)
  }, [previewHandle, propsPreviewURL])

  return (
    <Dialog.Root size="full" scrollBehavior="inside">
      <Dialog.Trigger asChild>{children}</Dialog.Trigger>
      <Dialog.Backdrop />
      <Portal>
        <Dialog.Positioner>
          <Dialog.Content
            borderRadius="card"
            // Inset the modal content.
            m={4}
            maxH="calc(100dvh - var(--chakra-spacing-4) * 2)"
            minH="calc(100dvh - var(--chakra-spacing-4) * 2)"
          >
            <Dialog.Header ref={headerRef} px={6} py={2}>
              <HStack w="full" justify="space-between" align="center">
                <Dialog.CloseTrigger asChild pos="static">
                  <IconButton
                    aria-label="Close preview"
                    variant="ghost"
                    size="sm"
                    rounded="full"
                  >
                    <Pathicon icon="x" />
                  </IconButton>
                </Dialog.CloseTrigger>
                <Button asChild variant="ghost">
                  <Link
                    variant="underline"
                    aria-label="Download file"
                    download
                    href={downloadURL}
                    tabIndex={0}
                  >
                    <Pathicon icon="download" />
                    Download
                  </Link>
                </Button>
              </HStack>
            </Dialog.Header>
            <Dialog.Body
              // Position body absolutely to allow iframe to fill the modal.
              pos="absolute"
              inset={0}
              top={`${headerHeight}px`}
              px={0}
            >
              {propsPreviewURL ? (
                <Box
                  as="img"
                  src={propsPreviewURL}
                  alt=""
                  w="100%"
                  h="100%"
                  minH="250px"
                  objectFit="contain"
                />
              ) : !!previewURL ? (
                <Box
                  id={PREVIEW_ID}
                  as="iframe"
                  // Allow only those scripts from same origin (which is likely no scripts).
                  // This will prevent odd UX like UX like when a PDF attempts to call window.print
                  // and would otherwise open the print dialogue.
                  sandbox="allow-scripts allow-same-origin"
                  src={previewURL}
                  w="100%"
                  h="100%"
                  minH="250px"
                  ml="0"
                />
              ) : null}
            </Dialog.Body>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  )
}

FilestackPreviewModal.propTypes = {
  // previewHandles: PropTypes.arrayOf(PropTypes.string).isRequired
  previewHandle: PropTypes.string.isRequired,
  previewURL: PropTypes.string,
  downloadURL: PropTypes.string.isRequired
}

export default FilestackPreviewModal
